<template>
  <div
    id="gp_autotest_invite_people_popupe_message_warning_upgrade_invite"
    :class="[$style.invite_upgrade_message, show ? $style.invite_upgrade_message__show : '']"
  >
    <div :class="$style.invite_upgrade_message__wrapper">
      <div :class="$style.description">
        <div>
          <svg-sprite
            :name="'warning-1'"
            color="#FF9A00"
            type="bold"
          />
        </div>
        <div :class="$style.text">
          {{ locales('invite_popup_out_licences') }}
        </div>
      </div>
      <vgp-button
        id="gp_autotest_invite_people_popup_btn_upgrade_invites"
        :class="$style.btn"
        type="text"
        :small="true"
        :label="locales('invites_add_more')"
        @onClick="$emit('upgradePlanShowFromResourcesForce')"
      />
    </div>
  </div>
</template>

<script>
import VgpButton from '../../../common/VueComponents/globalButton/vgpButton.vue';
import svgSprite from '$$vueCmp/VueIcon/svgSprite.vue';

export default {
  name: 'PricingInviteNoticiation',
  components: { VgpButton, svgSprite },
  props: {
    show: { type: Boolean, required: true, default: false },
  },
  emits: {
    upgradePlanShowFromResourcesForce: null,
  },
  data() {
    return {
      locales: __,
    };
  },
};
</script>

<style module src='./popups.less'></style>
